export default {
    type: null, //TODO: Think about price types, translations
    price: null, //TODO: <== it will be an index of the prices array
    register_type: null //Type of the user ticket for (if document - there will be admin fee applied)
}